import type { UserPermissionsProviderOptions } from '../types';

const MS_IN_SECOND = 1000;
const MS_IN_MINUTE = 60 * MS_IN_SECOND;
const STALE_TIME_MINUTES = 5;
const CACHE_TIME_MINUTES = 30;

/**
 * Default configuration for UserPermissionsContext
 */
const CONFIG: Required<UserPermissionsProviderOptions> = {
  refetchInterval: 0,
  staleTime: STALE_TIME_MINUTES * MS_IN_MINUTE,
  cacheTime: CACHE_TIME_MINUTES * MS_IN_MINUTE,
};

export default CONFIG;
